<template>
  <div>
    <!-- banner -->
    <div class="banner main mt-25 mb-25">
      <el-carousel height="460px" loop indicator-position="none" :interval="5000">
        <el-carousel-item v-for="(item,i) in bannerList" :key="i">
          <img :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 首页内容区域 -->
    <div class="content-box main flexHB">
      <div class="left">
        <div class="tabs flexHC">
          <div class="flexHC" v-if="categoryList.length">
            <span
                v-for="(item,i) in categoryList"
                :key="i"
                :class="categoryActive==item.id? 'curr': ''"
                @click="handleHomeCategory(item)"
                style="cursor: pointer;"
            >
              {{item.categoryName}}
            </span>
          </div>
          <a class="more" @click="jumpArticleList" style="cursor: pointer;">查看更多>></a>
        </div>

        <div class="list" v-if="articleList.length">
          <div class="item flexH"  v-for="(item,i) in articleList" :key="i" style="cursor: pointer;" @click="articleDetail(item)">
            <div>
              <img v-if="item.mainImage!=''" :src="item.mainImage" alt="">
              <div v-else class="time-box">
                <span class="num">{{item.releaseTimeDay}}</span>
                <span>/</span>
                <div>
                  <p>{{item.releaseTimeMonth}}月</p>
                  <p>{{item.releaseTimeYear}}</p>
                </div>
              </div>
            </div>
            <div>
              <p class="title fontE1" style="width: 520px;">{{item.articleTitle}}</p>
              <p class="desc fontE2 mb-10" style="width: 520px;">{{item.contentSummary}}</p>
              <p>
                <span class="time mr-33">{{item.releaseTime}}</span>
                <span class="name">{{item.articleOrigin}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="item mb-25"  v-if="zhongYangJingShen.length">
          <p>
            <span class="sm-title">中央精神</span>
          </p>
          <div class="box mt-30" style="cursor: pointer;" @click="articleDetail(zhongYangJingShen[0])">
            <img v-if="zhongYangJingShen[0].mainImage!=''" :src="zhongYangJingShen[0].mainImage" alt="">
            <div v-else class="time-box" style="border: none">
              <span class="num">{{zhongYangJingShen[0].releaseTimeDay}}</span>
              <span>/</span>
              <div>
                <p>{{zhongYangJingShen[0].releaseTimeMonth}}月</p>
                <p>{{zhongYangJingShen[0].releaseTimeYear}}</p>
              </div>
            </div>
            <div>
              <p class="title mt-20 fontE2">{{zhongYangJingShen[0].articleTitle}}</p>
              <p>
                <span class="time mr-33">{{zhongYangJingShen[0].releaseTime}}</span>
                <span class="name">{{zhongYangJingShen[0].articleOrigin}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="item mb-25 pb-0"  v-if="qiYeFengCai.length" >
          <p class="mb-43">
            <span class="sm-title ">企业风采</span>
          </p>
          <div class="box mt-30" v-for="(item,i) in qiYeFengCai" :key="i" style="cursor: pointer;" @click="articleDetail(item)">
            <img v-if="item.mainImage!=''" :src="item.mainImage" alt="">
            <div v-else class="time-box" style="border: none">
              <span class="num">{{item.releaseTimeDay}}</span>
              <span>/</span>
              <div>
                <p>{{item.releaseTimeMonth}}月</p>
                <p>{{item.releaseTimeYear}}</p>
              </div>
            </div>
            <div>
              <p class="title mt-20 fontE2">{{item.articleTitle}}</p>
              <p>
                <span class="time mr-33">{{item.releaseTime}}</span>
                <span class="name">{{item.articleOrigin}}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="item" >
          <p class="mb-43">
            <span class="sm-title ">会员动态</span>
          </p>
          <div class="mt-30" v-if="huiYuanDongTai.length>0">
            <img class="mb-54 status-img" :src="item.mainImage" alt="" v-for="(item,i) in huiYuanDongTai" :key="i" style="cursor: pointer;" @click="articleDetail(item)">
          </div>
        </div>
      </div>
    </div>

    <!-- 视频区域 -->
    <div class="vedio-box main mt-25"  v-if="videoList.length>0">
      <div class="title-box"><span class="curr">视频中心</span></div>
      <div class="mt-30 flexHB pl-30 pr-30">
        <div class="item" v-for="(item,i) in videoList" :key="i" @click="handleOpen(item)">
          <img v-if="item.mainImage!=''" :src="item.mainImage" alt="">
          <div v-else class="time-box">
            <span class="num">{{item.releaseTimeDay}}</span>
            <span>/</span>
            <div>
              <p>{{item.releaseTimeMonth}}月</p>
              <p>{{item.releaseTimeYear}}</p>
            </div>
          </div>
          <div>
            <p class="title mt-10 fontE1">{{item.videoTitle}}</p>
            <p class="mt-3 flexHB">
              <span class="time">{{item.releaseTime}}</span>
              <span class="name">{{item.videoOrigin}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 研究报告--人才招聘 -->
    <div class="main flexHB report-box mt-25">
      <div class="left">
        <div class="title-box"><span class="curr">研究报告</span></div>
        <div class="mt-30 pl-30 pr-30" style="position: relative;">
          <el-carousel ref="cardShow"  height="297px" arrow="never" loop indicator-position="none" :interval="3000">
            <el-carousel-item v-for="(item,i) in reportImgList" :key="i">
              <div class="item" @click="jumpUrl(item.downloadUrl)">
                <img :src="item.img" alt="">
                <p class="mt-10">{{item.text}}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="arrow-box">
            <img @click="prev" class="arrow-right" src="@/assets/img/icon_baogao_arrow2.svg" alt="">
            <img @click="next" src="@/assets/img/icon_baogao_arrow1.svg" alt="">
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title-box"><span class="curr">人才招聘</span></div>
        <div class="mt-30" v-if="renCaiZhaoPin.length>0">
          <div v-for="(item, index) in renCaiZhaoPin" :key="index" style="cursor: pointer;" @click="articleDetail(item)">
            <div class="item flexHB mb-30" v-if="index==0">
              <img class="mr-20" :src="item.mainImage" alt="">
              <div>
                <p class="title fontE2 mb-10">{{item.articleTitle}}</p>
                <p class="desc fontE2">{{item.contentSummary}}</p>
              </div>
            </div>
            <div class="item flexHB mt-20" v-else>
              <span class="title fontE1" style="width: 500px;">{{item.articleTitle}}</span>
              <span class="time">{{item.releaseTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="videoTitle"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
      <video v-if="videoUrl !=''"
             :src="videoUrl"
             controls="controls"
             οncοntextmenu="return false"
             :nofullscreen="videoNofullscreen"
             style="width: 100%;height: 100%;"
             controlsList="nodownload"
             disablePictureInPicture
             muted
             autoplay
      >您的浏览器不支持视频播放</video>
    </el-dialog>
  </div>
</template>
<script>
import { getHomeList } from '@/api/articleCategory'
import { postPageList, getHomeCategoryList } from '@/api/article'
import { postVideoPageList } from '@/api/video'
import { getHomeBannerList } from '@/api/homeBanner'

export default {
  data() {
    return {
      swiperIndex: 0,
      reportImgList: [
        {
          text: 'IT后市场数字化转型白皮书',
          downloadUrl: 'https://xianniu-image-dev.oss-cn-beijing.aliyuncs.com/cms/files/20230419/168190947225632.pdf',
          img:  require('@/assets/img/icon_book_img1.png')
        },
        {
          text: '2021年中国IT服务供应链数字化升级研究报告',
          downloadUrl: 'https://xianniu-image-dev.oss-cn-beijing.aliyuncs.com/cms/files/20230419/168190941855859.pdf',
          img:  require('@/assets/img/icon_book_img2.png')
        },
      ],
      bannerList: [],
      categoryList: [],
      categoryActive: '',
      parentId: '',
      articleList: [],
      page: 0,
      pageSize: 20,
      // --------------------
      // 视频 Start
      // -----------------------------------
      videoList: [],
      videoPage: 0,
      videoPageSize: 20,
      // --------------------
      // 视频 End
      // -----------------------------------
      categoryHome: [
        {
          label: '中央精神',
          value: 1,
          limit: 1
        },
        {
          label: '企业风采',
          value: 2,
          limit: 2
        },
        {
          label: '会员动态',
          value: 3,
          limit: 2
        },
        {
          label: '研究报告',
          value: 4,
          limit: 2
        },
        {
          label: '人才招聘',
          value: 5,
          limit: 4
        }
      ],
      zhongYangJingShen: {},
      qiYeFengCai: {},
      huiYuanDongTai: {},
      yanJiuBaoGao: {},
      renCaiZhaoPin: {},
      articleDetailUrl: '/article',
      articleListUrl: '/list',
      videoUrl: '',
      dialogVisible: false,
      videoTitle: '',
      videoNofullscreen: false
    }
  },
  methods: {
    handleClose(){
      this.videoUrl = ''
      this.dialogVisible = false
    },
    handleOpen( row ){
      this.videoUrl = row.videoUrl
      this.videoTitle = row.videoTitle
      this.dialogVisible = true
    },
    // 首页分类列表
    homeList() {
      const _t = this
      getHomeList().then((result)=>{
        if(result.status === 'OK'){
          _t.categoryList = result.data
          if(_t.categoryList.length>0){
            _t.categoryActive = _t.categoryList[0].id
            _t.parentId = _t.categoryList[0].parentId
          }
        }
      })
    },
    // 文章列表
    queryArticleList() {
      const _t = this
      postPageList({
        page: _t.page,
        pageSize: _t.pageSize,
        articleCategoryId: _t.categoryActive
      }).then((result)=>{
        if(result.status === 'OK'){
          _t.articleList = result.data.rows
        }
      })
    },
    // 视频列表
    queryVideoList(){
      const _t = this
      postVideoPageList({
        page: _t.page,
        pageSize: _t.pageSize
      }).then((result)=>{
        if(result.status == 'OK'){
          _t.videoList = result.data.rows
        }
      })
    },
    // 依据首页分类查询文章列表
    queryCategoryHomeList(){
      const _t = this
      _t.categoryHome.forEach(function (item, index){
        getHomeCategoryList({
          categoryName: item.label,
          limit: item.limit
        }).then((result)=>{
          if(result.status == 'OK'){
            _t.switchCategoryHome(item.value, result.data);
          }
        })
      })
    },
    // 匹配
    switchCategoryHome(index, data){
      const _t = this
      switch (index){
        case 1:
          _t.zhongYangJingShen = data
          break
        case 2:
          _t.qiYeFengCai = data
          break
        case 3:
          _t.huiYuanDongTai = data
          break
        case 4:
          _t.yanJiuBaoGao = data
          break
        case 5:
          _t.renCaiZhaoPin = data
          break
      }
    },

    prev() {
      this.$refs.cardShow.prev()
    },

    next() {
      this.$refs.cardShow.next()
    },
    // 跳转至文章详情
    articleDetail(article){
      // if(article.articleType==1){
        this.$router.push({
          path: this.articleDetailUrl,
          query: {
            id: article.id
          }
        })
      // }
    },
    jumpUrl( url ){
      window.open(url, '_blank')
    },
    // 轮播图
    getBannerList(){
      const _t = this
      getHomeBannerList().then((result)=>{
        if(result.status === 'OK'){
          _t.bannerList = result.data
        }
      })
    },
    // 分类点击
    handleHomeCategory(row){
      this.categoryActive = row.id
      this.parentId = row.parentId
    },
    // 查看更多
    jumpArticleList(){
      this.$router.push({
        path: this.articleListUrl,
        query: {
          parentId: this.parentId,
          categoryId: this.categoryActive
        }
      })
    }
  },
  watch: {
    categoryActive(){
      this.queryArticleList()
    }
  },
  async created() {
    await this.homeList()
    await this.queryVideoList()
    await this.queryCategoryHomeList()
    await this.getBannerList()
  }
}
</script>
<style lang="less" scoped>
.banner {
  img {
    width: 100%;
    height: 460px;
  }
}

.content-box {
  .left {
    width: 905px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
    padding: 0 30px;
  }
  .tabs {
    padding: 30px 0 21px 0;
    border-bottom: 1px solid #F8F8FB;
    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #909097;
      line-height: 28px;
      margin-right: 40px;
      position: relative;
      &.curr {
        color: #1B252C;
        &::after {
          width: 100%;
          height: 2px;
          background: #0D53BC;
          content: "";
          position: absolute;
          bottom: -20px;
          left: 0;
        }
      }
    }
    .more {
      font-size: 20px;
      color: #0D53BC;
      line-height: 28px;
      margin-left: auto;
    }
  }

  .item {
    padding: 30px 0;
    border-bottom: 1px solid #F8F8FB;
    img {
      width: 272px;
      height: 140px;
      margin-right: 60px;
      flex-shrink: 0;
    }
    .time-box {
      width: 272px;
      height: 140px;
      margin-right: 60px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 2px solid #C1C1C9;
      span {
        font-size: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #B7B7B7;
        line-height: 60px;
      }
      .num {
        font-size: 48px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0D53BC;
        line-height: 60px;
      }
      p {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #B7B7B7;
        line-height: 20px;
        margin-left: 4px;
      }
    }
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #171717;
      line-height: 30px;
      margin-bottom: 13px;
    }
    .desc {
      font-size: 14px;
      color: #5F5F6A;
      line-height: 24px;
    }
    .time {
      font-size: 14px;
      color: #909097;
      line-height: 30px;
    }
    .name {
      font-size: 14px;
      color: #0D53BC;
      line-height: 30px;
    }
  }

  .right {
    .item {
      padding: 30px;
      width: 350px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
      .box {
        border-bottom: 1px solid #F8F8FB;
        padding-bottom: 30px;
      }
      img {
        width: 290px;
        height: 160px;
      }
      .status-img:last-child {
        margin-bottom: 0 !important;
      }
      .sm-title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #1B252C;
        line-height: 28px;
        position: relative;
        &::after {
          position: absolute;
          bottom: -20px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #0D53BC;
          content: "";
        }
      }
    }
  }
}

.vedio-box  {
  height: 365px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
  padding: 30px;
  .item {
    width: 272px;
    img {
      width: 100%;
      height: 140px;
      margin-right: 60px;
    }
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #171717;
      line-height: 30px;
    }
    .time {
      font-size: 14px;
      color: #909097;
      line-height: 30px;
    }
    .name {
      font-size: 14px;
      color: #0D53BC;
      line-height: 30px;
    }
  }
  .time-box {
    width: 272px;
    height: 140px;
    margin-right: 60px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #C1C1C9;
    span {
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #B7B7B7;
      line-height: 60px;
    }
    .num {
      font-size: 48px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #0D53BC;
      line-height: 60px;
    }
    p {
      font-size: 14px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #B7B7B7;
      line-height: 20px;
      margin-left: 4px;
    }
  }
}
.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #F8F8FB;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1B252C;
      &::after {
        width: 100%;
        height: 2px;
        background: #0D53BC;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}

.report-box {
  .left {
    width: 535px;
    height: 435px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
    padding: 30px;
    .item {
      width: 415px;
      img {
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 255px;
      }
      p {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #171717;
        line-height: 30px;
      }
    }
    .arrow-box  img{
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 40%;
      width: 18px;
      height: 18px;
      &.arrow-right {
        right: initial;
        left: 0;
      }
    }
  }
  .right {
    padding: 30px;
    width: 720px;
    height: 435px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
    .item {
      img {
        width: 272px;
        height: 140px;
      }
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #171717;
        line-height: 30px;
      }

      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5F5F6A;
        line-height: 30px
      }
      .time {
        font-size: 14px;
        color: #909097;
        line-height: 30px;
      }
    }
  }
}
</style>
<style>
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
</style>
